module.exports = __webpack_public_path__ + "static/media/Isolation Effect, Von Restorff Effect mulyadi-dDlvuSKUDZM-unsplash.874d57fa.jpg";